import placeholderIcon from '@SvgIcon/../event-image-placeholder.svg'

import imagesLoaded from 'imagesloaded'
import $ from 'jquery'
import each from 'lodash/each'
import Swiper from 'swiper'
import { A11y } from 'swiper/modules'
import Vue from 'vue'

import { thumbUrlFromFileObject } from '../../shared/fileArrayUrl'
import svgIconHtml from '../../shared/svgIconHtml'
import { setupVideos } from '../_video'
import EventInstanceModal from '../module/calendar/EventInstanceModal'
import { transformRawEvent } from '../module/calendar/transformRawEvent'

import '../../../scss/app/home.scss'

const app = document.getElementById('app')

//
// Home panel audio
//

const homePanelAudio = document.getElementById('home-panel-audio')
const homePanelAudioToggle = document.getElementById('home-panel-audio-toggle')

if (homePanelAudio && homePanelAudioToggle) {
  const $playIcon = $(homePanelAudioToggle).find('.play')
  const $pauseIcon = $(homePanelAudioToggle).find('.pause')
  homePanelAudio.addEventListener('pause', () => {
    $playIcon.removeClass('visible')
    $pauseIcon.addClass('visible')
  })
  homePanelAudio.addEventListener('play', () => {
    $playIcon.addClass('visible')
    $pauseIcon.removeClass('visible')
  })
  if (homePanelAudio.hasAttribute('data-autoplay')) {
    homePanelAudio.play()
  }
  homePanelAudioToggle.addEventListener('click', () => {
    if (homePanelAudio.paused) {
      homePanelAudio.play()
    } else {
      homePanelAudio.pause()
    }
  })
}

//
// Home panel slider
//

function getAvailableHeight() {
  const htmlEl = document.documentElement

  let availableHeight = Math.max(
    htmlEl.clientHeight - (app.getBoundingClientRect().top + window.pageYOffset),
    800, // also adjust in home.scss -> .home-panel-wrap
  )

  document.querySelectorAll('.announcement-wrap').forEach((el) => {
    availableHeight -= el.offsetHeight
  })

  return availableHeight
}

function initializePanel(panelWrap) {
  if (!panelWrap) {
    return
  }

  const panelDims = panelWrap.getBoundingClientRect()

  const videoInjector = panelWrap.querySelector('.js-video-injector')
  if (videoInjector) {
    // Don't recreate existing video elements. It takes too long to reload video on mobile.
    if (!videoInjector.querySelector('iframe') && !videoInjector.querySelector('video')) {
      setupVideos(panelWrap, false)
    }
  }

  const panelText = panelWrap.querySelector('.home-panel__content-above-video')
  const panelIcons = panelWrap.querySelector('.home-panel__icons')

  const doMargins = () => {
    if (panelText) {
      panelText.style.marginTop = 0
      panelText.style.marginBottom = 0
      const textHeight = panelText.getBoundingClientRect().height
      const iconsHeight = panelIcons ? panelIcons.getBoundingClientRect().height : 0
      const totalWhitespace = panelDims.height - iconsHeight - textHeight - 30
      panelText.style.marginTop = `${totalWhitespace / 2}px`
      panelText.style.marginBottom = `${totalWhitespace / 2}px`
    }
  }

  if (panelIcons) {
    imagesLoaded(panelIcons, doMargins)
  } else {
    doMargins()
  }
}

function playAnimations(panelWrap, classNamePrefix) {
  if (!panelWrap) {
    return new Promise((resolve) => {
      resolve()
    })
  }

  return new Promise((resolve) => {
    const animationElements = panelWrap.querySelectorAll(`[class*="${classNamePrefix}animate__"]`)
    if (!animationElements.length) {
      resolve()
      return
    }

    let numAnimationsRunning = animationElements.length

    each(animationElements, (animateEl) => {
      const onAnimationEnd = () => {
        numAnimationsRunning -= 1
        animateEl.removeEventListener('animationend', onAnimationEnd)

        // Restore the original class name
        if ('app__origClassName' in animateEl) {
          animateEl.className = animateEl.app__origClassName
        }

        if (numAnimationsRunning <= 0) {
          resolve()
        }
      }

      /** @var Element animateEl */
      animateEl.addEventListener('animationend', onAnimationEnd)

      // Restore the original class name to eliminate any existing animations.
      if ('app__origClassName' in animateEl) {
        animateEl.className = animateEl.app__origClassName
      }
      // Store the original class name so we can reset the animations.
      animateEl.app__origClassName = animateEl.className

      // Play the animations
      const re = RegExp(`(${classNamePrefix}([^\\s]+))`, 'ig')
      const newClassName = animateEl.className.replace(
        re,
        (fullMatch, fullClassName, actualClassName) => actualClassName,
      )
      animateEl.className = `${newClassName} animate__animated`
    })
  })
}

function onPanelEnter(panelWrap) {
  if (!panelWrap) {
    return
  }

  if (panelWrap.hasAttribute('data-move-icon-bar')) {
    const iconBar = document.querySelector('.action-icons')
    if (iconBar && !panelWrap.querySelector('.action-icons')) {
      panelWrap.querySelector('.home-panel__content .cms-ve').appendChild(iconBar)
      iconBar.className += ' home-panel__icons'
    }
  }

  playAnimations(panelWrap, 'enter-').then()

  panelWrap.querySelectorAll('video').forEach((video) => {
    if (video.hasAttribute('data-src')) {
      video.setAttribute('src', video.getAttribute('data-src'))
      video.removeAttribute('data-src')
    }
  })

  initializePanel(panelWrap)
}

function initHome() {
  const swiperEl = document.getElementById('home-panel-swiper')
  const panelSelector = '.home-panel-wrap'
  const initializingClassName = 'is-initializing'

  if (swiperEl) {
    const isAutoHeight = swiperEl.hasAttribute('data-auto-height')

    // Try to prevent drastic page height shifts by setting visibility hidden:
    swiperEl.classList.add(initializingClassName)

    let autoplayTimeout = null
    let autoplayTimeoutPausedByVisibilityChange = false

    // const makeOnlyVisiblePanelsFocusable = () => {
    //   const focusableElemsSelector = 'a, button, input, textarea, [tabindex=0], select'
    //   $panelsContainer.find(panelSelector).each((i, panel) => {
    //     $(panel).find(focusableElemsSelector).attr('tabindex', '-1')
    //   })
    //   $(activePanel).find(focusableElemsSelector).removeAttr('tabindex')
    // }

    const numSlides = swiperEl.querySelectorAll(panelSelector).length
    const availableHeight = isAutoHeight ? null : getAvailableHeight()
    if (availableHeight !== null) {
      swiperEl.style.setProperty('--panel-height', `${availableHeight}px`)
    } else {
      swiperEl.style.removeProperty('--panel-height')
    }

    const swiperOptions = {
      modules: [A11y],
      a11y: true,
      autoHeight: isAutoHeight,
      setWrapperSize: true,
      threshold: 40,
      loop: numSlides > 1,
      on: {
        init(swpr) {
          /**
           * @return HTMLButtonElement
           */
          const createButton = (className, ariaLabel, html) => {
            const arrow = document.createElement('button')
            arrow.className = `slider-btn ${className}`
            arrow.type = 'button'
            arrow.setAttribute('aria-label', ariaLabel)
            arrow.innerHTML = html
            return arrow
          }

          const goNext = () => {
            return new Promise((resolve) => {
              swpr.slideNext()
              resolve()
            })
          }

          const goPrev = () => {
            return new Promise((resolve) => {
              swpr.slidePrev()
              resolve()
            })
          }

          const panels = swiperEl.querySelectorAll(panelSelector)
          if (panels.length > 1) {
            // Set up prev/next arrows:
            const prevArrow = createButton(
              'slider-btn-prev',
              'Previous slide',
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>',
            )
            prevArrow.onclick = () => {
              clearTimeout(autoplayTimeout)
              goPrev().then()
            }

            const nextArrow = createButton(
              'slider-btn-next',
              'Next slide',
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>',
            )
            nextArrow.onclick = () => {
              clearTimeout(autoplayTimeout)
              goNext().then()
            }

            const buttonsFragment = document.createDocumentFragment()
            buttonsFragment.appendChild(prevArrow)
            buttonsFragment.appendChild(nextArrow)
            swiperEl.appendChild(buttonsFragment)
          }

          swiperEl.classList.remove(initializingClassName)
          if (panels.length) {
            onPanelEnter(Array.from(panels)[0])
          }

          // Timeout so that exit animations have a chance to play.
          const nextTimeout = () => {
            const showForSeconds = parseInt(swpr.slides[swpr.realIndex].getAttribute('data-show-for'), 10)
            autoplayTimeout = setTimeout(
              async () => {
                await goNext()
                nextTimeout()
              },
              !Number.isNaN(showForSeconds) && showForSeconds > 0 ? showForSeconds * 1000 : 5500,
            )
          }
          nextTimeout()

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden' || document.hidden) {
              if (autoplayTimeout) {
                autoplayTimeoutPausedByVisibilityChange = true
              }
              clearTimeout(autoplayTimeout)
            } else if (autoplayTimeoutPausedByVisibilityChange) {
              autoplayTimeoutPausedByVisibilityChange = false
              nextTimeout()
            }
          })
        },
      },
    }

    if (availableHeight !== null) {
      swiperOptions.height = availableHeight
    }

    const swiper = new Swiper(swiperEl, swiperOptions)

    swiper.on('touchStart', () => {
      clearTimeout(autoplayTimeout)
    })

    swiper.on('slideChange', (swpr) => {
      onPanelEnter(swpr.slides[swpr.realIndex])
    })

    // Observe new panels:

    const panelObserver = new MutationObserver((mutations) => {
      each(mutations, (mutation) => {
        each(mutation.addedNodes, (node) => {
          if (node.nodeType !== 1) {
            return
          }

          node.querySelectorAll(panelSelector).forEach((panelWrap) => {
            initializePanel(panelWrap)
          })
        })
      })
    })

    panelObserver.observe(swiperEl, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    })
  }
}

if (module.hot) {
  $(window).on('load', initHome)
} else {
  initHome()
}

//
// Events
//

const eventsAppContainer = document.querySelector('.js-events')
if (eventsAppContainer) {
  new Vue({
    components: {
      EventInstanceModal,
    },
    name: 'EventsWidget',
    el: eventsAppContainer,
    props: {
      events: Array,
    },
    propsData: {
      events: JSON.parse(eventsAppContainer.dataset.events).map(transformRawEvent),
    },
    template: `
      <div class="event-widget">
        <p v-if="events.length === 0" class="text-center">
          Nothing scheduled. Check back soon!
        </p>
        <div v-else class="event-widget__events">
          <button
              v-for="event in events"
              class="event-widget__event"
              @click="viewEvent(event)"
          >
            <div class="event-widget__event-photo is-custom-photo" v-if="eventPhotoThumbUrl(event)">
              <img :src="eventPhotoThumbUrl(event)" alt="">
              <template v-else>${svgIconHtml(placeholderIcon)}</template>
            </div>
            <div class="event-widget__event-photo is-default-photo" v-else>
              ${svgIconHtml(placeholderIcon)}
            </div>
            <div class="event-widget__event-date">
              <div class="start date">
                <div class="month">{{ event.dateStartMoment.format('MMM') }}</div>
                <div class="day">{{ event.dateStartMoment.format('D') }}</div>
              </div>
              <div class="end date" v-if="event.dateStart !== event.dateEnd">
                <div class="month">{{ event.dateEndMoment.format('MMM') }}</div>
                <div class="day">{{ event.dateEndMoment.format('D') }}</div>
              </div>
            </div>
            <div class="event-widget__event-info">
              <div class="event-widget__event-title">{{ event.title }}</div>
              <div v-if="event.cancelled" class="event-widget__event-cancelled">Cancelled!</div>
            </div>
          </button>
        </div>
        <EventInstanceModal ref="modal" />
      </div>
    `,
    methods: {
      viewEvent(event) {
        this.$refs.modal.show(event.title, event.dataUrl)
      },

      eventPhotoThumbUrl(event) {
        return thumbUrlFromFileObject(event.photo)
      },
    },
  })
}
